import React from "react";
import BathroomsIcon from "@streeteasy/design-system/deprecated/Icons/SVG/BathroomsIcon";
import BedroomsIcon from "@streeteasy/design-system/deprecated/Icons/SVG/BedroomsIcon";
import SquareFootageIcon from "@streeteasy/design-system/deprecated/Icons/SVG/SquareFootageIcon";
import { number, oneOfType, string } from "prop-types";

import { formatNumber } from "src/shared/utilities/formatNumber";

import * as S from "./styled";

const ListingInfo = ({ bath, beds, squareFootage }) => {
  let bedsText;

  switch (Number(beds)) {
    case 1:
      bedsText = "1 Bed";
      break;
    case 0:
      bedsText = "Studio";
      break;
    default:
      bedsText = `${Number(beds)} Beds`;
  }

  return (
    <S.RoomInfoContainer>
      <S.RoomInfoItem>
        <BedroomsIcon desktopPadding="0 7px 0 0" />
        <S.RoomInfoText>{bedsText}</S.RoomInfoText>
      </S.RoomInfoItem>
      <S.RoomInfoItem>
        <BathroomsIcon desktopPadding="0 8px 0 0" width="16px" />
        <S.RoomInfoText>
          {Number(bath) > 1 ? `${Number(bath)} Baths` : "1 Bath"}
        </S.RoomInfoText>
      </S.RoomInfoItem>
      {squareFootage && Number(squareFootage) > 0 && (
        <S.RoomInfoItem squareFootage={squareFootage}>
          <SquareFootageIcon desktopPadding="0 10px 0 0" />
          <S.RoomInfoText>
            {formatNumber(squareFootage)} ft<sup>2</sup>
          </S.RoomInfoText>
        </S.RoomInfoItem>
      )}
    </S.RoomInfoContainer>
  );
};

ListingInfo.propTypes = {
  bath: oneOfType([number, string]).isRequired,
  beds: oneOfType([number, string]).isRequired,
  squareFootage: oneOfType([number, string])
};

ListingInfo.defaultProps = {
  squareFootage: null
};

export default ListingInfo;
